"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StatusCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseConversion = require("nicbase-conversion");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var lengthUnit = state.user.lengthUnit;
  return {
    lengthUnit: lengthUnit
  };
};

var StatusCell = function StatusCell(_ref) {
  var cellData = _ref.cellData,
      lengthUnit = _ref.lengthUnit;
  var _cellData$status = cellData.status,
      status = _cellData$status === void 0 ? null : _cellData$status,
      _cellData$distanceToP = cellData.distanceToPoi,
      distanceToPoi = _cellData$distanceToP === void 0 ? null : _cellData$distanceToP;

  if (!status) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tour.status.".concat(status)
  }, function (state) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "flex"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "mr-1"
    }, state), distanceToPoi !== null && [/*#__PURE__*/_react["default"].createElement("span", {
      className: "mr-1"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.EndStop, {
      className: "inline-block"
    })), /*#__PURE__*/_react["default"].createElement(_nicbaseConversion.FormattedUnit, {
      value: distanceToPoi / 1000,
      from: "km",
      to: lengthUnit,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })]);
  });
};

exports.StatusCell = StatusCell;
StatusCell.propTypes = {
  cellData: _propTypes["default"].shape({
    status: _propTypes["default"].string,
    distanceToPoi: _propTypes["default"].number
  }),
  lengthUnit: _propTypes["default"].string
};
StatusCell.defaultProps = {
  cellData: {
    status: null,
    distanceToPoi: null
  },
  lengthUnit: ''
};
var ConvertedStatus = (0, _reactRedux.connect)(mapStateToProps)(StatusCell);

var renderer = function renderer(_ref2) {
  var cellData = _ref2.cellData;
  return /*#__PURE__*/_react["default"].createElement(ConvertedStatus, {
    cellData: cellData
  });
};

renderer.propTypes = {
  cellData: _propTypes["default"].shape({
    status: _propTypes["default"].string,
    distanceToPoi: _propTypes["default"].number
  })
};
renderer.defaultProps = {
  cellData: {
    status: null,
    distanceToPoi: null
  }
};
var _default = renderer;
exports["default"] = _default;